import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from './breadcrumbs.service';
import { FormGroup, NgForm, FormBuilder, Validators } from '@angular/forms';
import { I18nService } from 'src/app/services/i18n.service';
declare var $:any;

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit {
  currentLang;
  breadcrumbItems: {
    id: number;
    title: string;
    link: string;
    params: any;
    
  }[] = [];
  form:FormGroup;
  formSubmitted = false;

  constructor(private breadcrumbsService: BreadcrumbsService,
    private i18nService: I18nService,
    private fb: FormBuilder) { 
      this.i18nService.getLang().subscribe((lng) => {
        if(lng == null){
          lng = 'ar';
        }
        this.currentLang = lng;
      });
      this.form = this.fb.group({
        email: ['', Validators.required],
        emailTo: ['', Validators.required],
        comment: ['', Validators.required],
      });
    }
  

  ngOnInit() {
    this.breadcrumbsService.breadcrumbItemsEvent.subscribe(items => {
      this.breadcrumbItems = items;
    });

    
  }


  print(){
    window.print();
  }
  share(){
    this.formSubmitted = true;
    if(this.form.status == "VALID"){
      $("#dismiss").click();
    }
    
  }
  createBookmark() {
    if (this.currentLang == 'ar') {
      alert("اضغط على Command / Cmd / ctrl + D لوضع إشارة مرجعية على هذه الصفحة.");
    } else {
      alert("Press Command/Cmd/ctrl + D to bookmark this page.");
    }
  }
}
